import { bridge } from '../../../bridge';

export const moveToRoot = () => {
  bridge.openDeeplink('ably://react/App?screen=Home', {
    // webPath: '/',
    webCallback: () => {},
  });
};
